module.exports = __webpack_public_path__ + "img/copy-03.9a72e805.svg";